// frontend/src/App.js
import React from 'react';
import AppRoutes from './routes'; // 👈 using routes.js

const App = () => {
  return <AppRoutes />;
};

export default App;
